<div class="card">
  <h5 class="card-header">Bills - Top 10</h5>
  <div class="card-body">
    <table class="table table-docs table-hover">
      <thead>
        <tr>
          <th>S.N.</th>
          <th *ngFor="let h of headers">{{h.name}}</th>
        </tr>
      </thead>

      <tbody [ngStyle]="{'display': s3List.length > 0 ? 'table-row-group': ''}">
        <tr *ngFor="let i of s3List; let j = index">
          <td>{{j+1}}</td>
          <td *ngFor="let h of headers">
            <span *ngIf="h.click" class="btn" (click)="callFunction(h.click, i)">
              <span (click)="callFunction(h.click,i)">
                {{i[h.id]}}
              </span>
            </span>
            <span *ngIf="!h.click">
              <span *ngIf="h.color">
                <span [ngStyle]="{'color': h.color(i[h.id])}">{{i[h.id]}}</span>
              </span>
              <span *ngIf="!h.color">
                <span>{{i[h.id]}}</span>
              </span>
            </span>
          </td>
        </tr>
      </tbody>
      <tbody [ngStyle]="{'display': s3List.length == 0 ? 'table-row-group' : 'none'}">
        <tr>
          <td [attr.colspan]="headers.length + 1">
            <div style="text-align: center;">No Data Found</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>